import { type IssueFieldQuestionMap } from "services/issues/issuesStore";

export enum DirectorSoleTraderQuestion {
  Name = "DIRECTOR_NAME",
  Birthday = "DIRECTOR_BIRTHDAY",
  Address = "DIRECTOR_ADDRESS",
  TaxFileNumber = "DIRECTOR_TAX_FILE_NUMBER",
}

export const DIRECTOR_FIELD_TO_QUESTION: IssueFieldQuestionMap<DirectorSoleTraderQuestion> = {
  dob: DirectorSoleTraderQuestion.Birthday,
  first_name: DirectorSoleTraderQuestion.Name,
  middle_names: DirectorSoleTraderQuestion.Name,
  last_name: DirectorSoleTraderQuestion.Name,
  address: DirectorSoleTraderQuestion.Address,
  service_address: DirectorSoleTraderQuestion.Address,
};

export const DIRECTOR_FIELD_TO_PATH: Record<DirectorSoleTraderQuestion, string> = {
  [DirectorSoleTraderQuestion.Name]: "name",
  [DirectorSoleTraderQuestion.Birthday]: "birthday",
  [DirectorSoleTraderQuestion.Address]: "address",
  [DirectorSoleTraderQuestion.TaxFileNumber]: "tfn",
};
